export default __webpack_public_path__ + "a9046443ea03eb941e9e1e01214fe49b.png";